"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.attachmentType = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _propTypes = require("prop-types");

var _react = require("react");

var _dayjs = _interopRequireDefault(require("dayjs"));

var _icons = require("../../assets/icons");

var _elements = require("../../styles/elements");

var _util = require("../../util");

var _Attachments = require("./Attachments.styles");

/* eslint-disable react/jsx-no-bind */
var isLoading = function isLoading(progress) {
  return (0, _util.isNumeric)(progress) && progress < 100;
};

var attachmentType = (0, _propTypes.shape)({
  id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  name: _propTypes.string,
  size: _propTypes.number,
  progress: _propTypes.number,
  uploader: (0, _propTypes.shape)({
    firstName: _propTypes.string
  })
});
exports.attachmentType = attachmentType;

var Attachment = function Attachment(_ref) {
  var className = _ref.className,
      attachment = _ref.attachment,
      onRemove = _ref.onRemove,
      onUploadFile = _ref.onUploadFile,
      disabled = _ref.disabled;

  var _ref2 = attachment || {},
      id = _ref2.id,
      size = _ref2.size,
      name = _ref2.name,
      progress = _ref2.progress,
      url = _ref2.url,
      added = _ref2.added,
      _ref2$uploader = _ref2.uploader,
      uploader = _ref2$uploader === void 0 ? {} : _ref2$uploader,
      failed = _ref2.failed,
      error = _ref2.error;

  var info = (0, _react.useMemo)(function () {
    if (failed || error) {
      // The upload failed (error from onerror event)
      return (0, _jsxRuntime.jsx)("span", {
        css: _elements.text.styles.textNegative,
        children: failed ? 'Upload failed: An error occurred' : error
      });
    }

    if (isLoading(progress)) {
      // Uploading
      return "Uploading (".concat(progress, "%)");
    } // Upload success


    return "Added ".concat((0, _dayjs["default"])(added).format('D MMMM, YYYY'), " by ").concat(uploader.firstName);
  }, [added, error, failed, progress, uploader.firstName]);
  return (0, _jsxRuntime.jsxs)("div", {
    css: _Attachments.styles.attachment,
    className: className,
    children: [(0, _jsxRuntime.jsxs)("div", {
      className: "grui flex-1 overflow-hidden",
      children: [(0, _jsxRuntime.jsxs)("h5", {
        className: "grui flex mb-4",
        children: [(0, _jsxRuntime.jsxs)("span", {
          className: "grui truncate",
          children: [name, "\xA0"]
        }), (0, _jsxRuntime.jsx)("span", {
          className: "grui whitespace-nowrap",
          children: "(".concat((0, _util.humanFileSize)(size), ")")
        })]
      }), info]
    }), (0, _jsxRuntime.jsxs)("div", {
      css: _Attachments.styles.controls,
      children: [failed && (0, _jsxRuntime.jsx)("button", {
        css: _elements.button.styles.preflight,
        type: "button",
        onClick: function onClick() {
          return onUploadFile(id, failed);
        },
        children: (0, _jsxRuntime.jsx)(_icons.Reset, {})
      }), url && (0, _jsxRuntime.jsx)("a", {
        href: url,
        target: "_blank",
        rel: "noreferrer",
        children: (0, _jsxRuntime.jsx)(_icons.ExternalLink, {})
      }), !disabled && (0, _jsxRuntime.jsx)("button", {
        css: _elements.button.styles.preflight,
        type: "button",
        onClick: function onClick() {
          return onRemove(id);
        },
        disabled: disabled,
        children: (0, _jsxRuntime.jsx)(_icons.Close, {})
      })]
    })]
  });
};

Attachment.propTypes = {
  className: _propTypes.string,
  attachment: attachmentType,
  onRemove: _propTypes.func,
  onUploadFile: _propTypes.func,
  disabled: _propTypes.bool
};
Attachment.defaultProps = {
  className: undefined,
  attachment: {},
  onRemove: function onRemove() {},
  onUploadFile: function onUploadFile() {},
  disabled: false
};
var _default = Attachment;
exports["default"] = _default;
//# sourceMappingURL=Attachment.js.map